/**
 * Manual task type emitted by the customer-queries agent when it proposes
 * customer-info changes for review. Used to register the definition and to route
 * the inbox preview pane.
 */
export const CUSTOMER_INFO_REVIEW_TYPE = 'REVIEW_CUSTOMER_UPDATE_AGENT_OUTPUT'

/**
 * Fixed width of the editable form panel (the right column) in the review modal.
 * The left preview column flexes to fill the remaining space, mirroring the
 * contract intake review's `1fr auto` two-panel layout. 560px of form content
 * plus 24px of padding on each side.
 */
export const REVIEW_FORM_PANEL_WIDTH = '608px'
